import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { useCreateMealPlan } from "@/hooks/features/use-create-meal-plan";
import { useGetFeedback } from "@/hooks/requests/feedback/use-get-feedback";
import { useIonRouter } from "@ionic/react";
import { useEffect, useState } from "react";
import MealCreatingProgress from "../../components/meal-creating-progress";

export default function GoToProfilingCreating() {
  const navigation = useIonRouter();
  const [isCompleted, setIsCompleted] = useState(false);
  const { feedback } = useGetFeedback();
  const { allGenerationStatus } = useCreateMealPlan(() => {
    setIsCompleted(true);
  });

  useEffect(() => {
    if (isCompleted) {
      if (feedback?.plan_setup) {
        navigation.push("/plans/my-plan", "forward", "replace");
      } else {
        navigation.push("/profiling/go-to/feedback", "forward", "replace");
      }
    }
  }, [isCompleted]);

  return (
    <ProfilePageContainer
      showToolbar={false}
      className="h-full flex flex-col items-center justify-center"
    >
      <MealCreatingProgress statues={allGenerationStatus?.statuses} />
    </ProfilePageContainer>
  );
}
